import { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { callLSQLapp, encryptBody, getLsqLeadBody } from "../services/lsq.js";

import {
  ctaClickEvent,
  formAbandonmentEvent,
  formFieldErrorEvent,
  formIntermediateEvent,
  formStartEvent,
  formSubmissionFailEvent,
  formSuccessEvent,
} from "../services/adobeDataLayer.js";

import queryString from "query-string";
import { useCookies } from "react-cookie";

function FormComponent() {
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    reset,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange", // enables real-time validation
  });

  function showToast(type, message) {
    const toast = document.createElement("div");
    toast.className = `toast ${type}`;
    toast.textContent = message;

    document.getElementById("toastContainer").appendChild(toast);

    setTimeout(() => {
      toast.remove();
    }, 3000);
  }

  // const [loanAmount, setLoanAmount] = useState(60000); // default value
  const [showSendOtp, setShowSendOtp] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);
  const [isVisible, setIsVisible] = useState(true);

  const mobileValue = watch("mobile");

  //States for Pincode and City
  const [cityName, setCityName] = useState("");
  const [citydefined, setCitydefined] = useState(false);

  //Store lead create payload values
  const formValuesRef = useRef({});

  //Store Fbp and Fbc from cookies
  const [cookies, setCookie] = useCookies();
  formValuesRef.current.FBClickID = cookies["_fbp"] || "";
  formValuesRef.current.FBPixelID = cookies["_fbc"] || "";

  const hasTriggeredFormStart = useRef(false);
  let lastAccessedField = "na";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      //console.log("lead form started: ", hasTriggeredFormStart.current)
      // Custom logic to be executed before tab or window is closed
      if (hasTriggeredFormStart.current) {
        formAbandonmentEvent(
          "BT NCA lead form",
          "lead generation",
          lastAccessedField,
          "details",
        );
        //console.table(window.adobeDataLayer)
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    //Clean Up
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  //Display Send OTP or not
  useEffect(() => {
    if (/^\d{10}$/.test(mobileValue)) {
      setShowSendOtp(true);
    } else {
      setShowSendOtp(false);
    }
  }, [mobileValue]);

  // Timer countdown
  useEffect(() => {
    if (otpSent && timer > 0 && !otpVerified) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
        if (timer <= 1) {
          setIsVisible(!isVisible);
        }
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [otpSent, timer, otpVerified]);

  const handleSendOtp = async () => {
    ctaClickEvent(`otp:${otpSent}`, "lead form", "button", 0, "na");
    if (!mobileValue) return;
    if (mobileValue.length === 10) {
      try {
        let payload = { mobile: mobileValue, messageType: "otpGeneral" };
        let param = { otp: "send" };
        const res = await callLSQLapp(payload, "OTP", param);
        if (res.data.message.response.sent) {
          formIntermediateEvent("receive", "otp");
          showToast("success", "An OTP has been sent to your Mobile number.");
          setOtpVerified(false);
          setTimer(60);
          setOtpSent(true);
          setIsVisible(!isVisible);
        }
      } catch (error) {
        showToast("error", "Error occurred while generating OTP.");
      }
    }
  };

  const handleVerifyOtp = async () => {
    ctaClickEvent("otp:verify", "lead form", "button", 0, "na");
    if (!mobileValue) {
      showToast("error", "Please enter mobile number");
      return;
    }
    if (otp.length === 6) {
      try {
        let payload = { mobile: mobileValue, otp: otp };
        let param = { otp: "verify" };
        const res = await callLSQLapp(payload, "OTP", param);
        if (res.data.message === "Failure Occured, please check logs") {
          showToast("error", "Please enter valid OTP");
        } else {
          formIntermediateEvent("verified", "otp");
          setOtpVerified(true);
          setTimer(0);
          showToast("success", "OTP verified.");
          setIsVisible(!isVisible);
          formValuesRef.current.token =
            res.data.message.response.dataSent.UniqueID;
        }
      } catch (error) {
        showToast("error", "Error verifying OTP.");
      }
    }
  };

  const handlePincode = async (e) => {
    if (e.target.value?.length === 6) {
      setCityName("Fetching...");
      let payload = { pincode: e.target.value };
      let param = { type: "pincode" };
      const response = await callLSQLapp(payload, "MAVIS", param);
      const { uniqueArray, filteredCount } = response.data.message;
      if (filteredCount > 0) {
        let CityNameIs = uniqueArray[0].District;
        console.log("cityName is", CityNameIs);
        setCityName(CityNameIs);
        setCitydefined(true);
      } else {
        setCityName("City not found");
        setCitydefined(false);
      }
    }
  };

  const handleFormStart = () => {
    if (!hasTriggeredFormStart.current) {
      formStartEvent("BT NCA lead form", "lead generation", "details");
      hasTriggeredFormStart.current = true;
    }
  };

  const handleReset = () => {
    reset();
    setOtp("");
    setOtpSent(false);
    setOtpVerified(false);
    setTimer(60);
    setShowSendOtp(false);
    // setLoanAmount(60000);
  };

  const onError = (errors) => {
    const simpleErrors = Object.fromEntries(
      Object.entries(errors).map(([key, value]) => [key, value.message]),
    );
    formFieldErrorEvent(simpleErrors);
    console.log("Simplified errors:", simpleErrors);
  };

  const onSubmit = async (data) => {
    if (!otpSent && mobileValue.length === 10) {
      showToast("error", "Click on Send OTP to continue.");
      return;
    } else if (!otp) {
      showToast("error", "Please enter OTP to continue.");
      return;
    } else if (!otpVerified) {
      showToast("error", "Please verify OTP to continue.");
      return;
    }

    if (!citydefined) {
      showToast("error", "Please enter valid pincode.");
    }

    formValuesRef.current.fullname = data.fullName;
    formValuesRef.current.mobile = data.mobile;
    formValuesRef.current.email = data.email;
    formValuesRef.current.pan = data.pan;
    formValuesRef.current.pincode = data.pincode;
    // formValuesRef.current.homeLoanAmountRequired = data.homeloan_req;
    formValuesRef.current.CityName = cityName;

    const utmParamsObj = queryString.parse(window.location.search);
    for (const [key, value] of Object.entries(utmParamsObj)) {
      if (key !== "campaign_code") {
        formValuesRef.current[key] = value;
      }
    }

    formValuesRef.current.CampaignId = "819313";
    formValuesRef.current.ApiProductName = "BT NCA";

    formValuesRef.current.UserName = "homeloan";
    formValuesRef.current.Password = "homeloan";
    formValuesRef.current.ApiCompanyName = "internal";
    formValuesRef.current.ParentProduct = "Home Loan";
    formValuesRef.current.ModeOfLead = "landing-page";
    if (data.agreetnc === true) {
      formValuesRef.current.DND = "Yes";
      formValuesRef.current.terms_chk = true;
    } else {
      formValuesRef.current.DND = "No";
      formValuesRef.current.terms_chk = false;
    }

    formValuesRef.current.IsEligible = "Yes";
    formValuesRef.current.EligibilityReason = "";
    formValuesRef.current.CompleteUrl = window.location.href;
    formValuesRef.current.User_Agent = navigator.userAgent;

    console.log("Final Submitted Data:", formValuesRef);

    let payload = {
      mobile: data.mobile,
      otp: otp,
      formdata: getLsqLeadBody(formValuesRef.current),
    };
    console.log("Lead Create Payload", payload);

    //Encrypt Payload
    const encryptedPayload = await encryptBody(payload);
    // console.log("Lead Create encrypted Payload", encryptedPayload);

    let param = {};
    let createLeadResp = await callLSQLapp(encryptedPayload, "CREATE", param);
    if (createLeadResp.data.message !== "Failure occured , please check logs") {
      formSuccessEvent(
        "BT NCA lead form",
        { otp: otp, pincode: data.pincode, city: cityName },
        "lead generation",
        "thank you",
        true,
      );
      let leadid = createLeadResp.data.message.Data.LeadApiCalls.Message.Id;
      console.log("leadID", leadid);
      navigate(`/thankyou?id=${leadid}`);
    } else {
      formSubmissionFailEvent();
      console.log("lead not created.");
    }
  };

  return (
    <form
      onSubmit={handleSubmit(onSubmit, onError)}
      onChange={handleFormStart}
      id="myForm"
    >
      <h3>Apply now to get instant sanction</h3>
      <div className="px-3 py-2">
        <div className="input_wrapper">
          <input
            type="text"
            id="name"
            placeholder="Full Name (As per PAN)"
            disabled={otpVerified}
            {...register("fullName", {
              required: "Full name is required",
              pattern: {
                value: /^[a-zA-Z\s]+$/,
                message: "Only alphabets and spaces allowed",
              },
            })}
            onInput={(e) => {
              e.target.value = e.target.value.replace(/[^a-zA-Z\s]/g, "");
            }}
          />

          {errors.fullName && (
            <span className="error">{errors.fullName.message}</span>
          )}
        </div>

        {/* Mobile Number */}
        <div className=" otp_wrapper input_wrapper">
          <div className="d-flex align-items-center gap-2 ">
            <input
              type="text"
              id="mobile"
              placeholder="Mobile Number"
              disabled={otpVerified}
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={10}
              {...register("mobile", {
                required: "Mobile number is required",
                pattern: {
                  value: /^\d{10}$/,
                  message: "Enter valid 10-digit mobile number",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
              }}
            />
            {showSendOtp && !otpVerified && isVisible && (
              <div className="">
                <button
                  type="button"
                  className="resend"
                  id="sendOtpBtn"
                  onClick={handleSendOtp}
                >
                  {!otpSent ? `Send OTP` : `Resend OTP`}
                </button>
              </div>
            )}
          </div>
          {errors.mobile && (
            <span className="error">{errors.mobile.message}</span>
          )}
        </div>

        {/* OTP Field */}
        {otpSent && !otpVerified && timer != 0 && (
          <div className="otp_wrapper input_wrapper">
            <div className="d-flex align-items-center gap-2 ">
              <input
                type="text"
                id="otp"
                placeholder="Enter the OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
                inputMode="numeric"
              />
              <span className="timer">
                {timer < 10 ? `00:0${timer}` : `00:${timer}`}
              </span>
              <button
                type="button"
                className="resend"
                id="verifyOtpBtn"
                onClick={handleVerifyOtp}
              >
                Verify OTP
              </button>
            </div>
            {errors.otp && <span className="error">{errors.otp.message}</span>}
          </div>
        )}

        <div className="input_wrapper">
          <input
            type="text"
            placeholder="Email ID"
            id="email"
            {...register("email", {
              required: "Email is required",
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: "Enter valid email",
              },
            })}
          />

          {errors.email && (
            <span className="error">{errors.email.message}</span>
          )}
        </div>

        {/* PAN Field */}
        <div className="input_wrapper">
          <input
            type="text"
            id="pan"
            placeholder="PAN Number"
            maxLength={10}
            {...register("pan", {
              required: "PAN number is required",
              pattern: {
                value: /^[A-Z]{5}\d{4}[A-Z]$/,
                message: "Invalid PAN format",
              },
            })}
            onInput={(e) => {
              e.target.value = e.target.value.toUpperCase();
            }}
          />

          {errors.pan && <span className="error">{errors.pan.message}</span>}
        </div>

        <div className="">
          <div className="position-relative input_wrapper">
            <input
              type="text"
              id="pincode"
              placeholder="Property PIN code"
              inputMode="numeric"
              pattern="[0-9]*"
              maxLength={6}
              {...register("pincode", {
                required: "Property PIN code is required",
                pattern: {
                  value: /^\d{6}$/,
                  message: "Enter valid 6-digit PIN Code number",
                },
              })}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
              }}
              onChange={handlePincode}
            />

            {errors.pincode && (
              <span className="error">{errors.pincode.message}</span>
            )}
          </div>
          <div className="position-relative input_wrapper">
            <input
              type="text"
              id="city"
              placeholder="City (Auto fetch)"
              value={cityName}
              disabled
              readOnly
            />
          </div>
        </div>

        <button
          type="button"
          className="reset"
          id="resetBtn"
          onClick={handleReset}
        >
          Reset Details
        </button>

        <div
          className="position-relative terms input_wrapper d-flex align-items-start justify-content-center mt-3 agreetncwrap"
          style={{ gap: "10px" }}
        >
          <Controller
            name="agreetnc"
            control={control}
            defaultValue={false}
            rules={{
              validate: (value) =>
                value === true || "Agree Terms and Condition",
            }}
            render={({ field }) => (
              <input
                type="checkbox"
                id="agreetnc"
                style={{ width: "fit-content" }}
                checked={field.value}
                {...register("agreetnc", {
                  required: "Agree Terms and Condition",
                })}
                onChange={(e) => {
                  field.onChange(e.target.checked);
                  ctaClickEvent(
                    `consent checkbox: ${e.target.checked}`,
                    "lead form",
                    "checkbox",
                    0,
                    "na",
                  );
                }}
              />
            )}
          />
          <label for="agreetnc">
            I agree to be bound by these{" "}
            <a
              target="_blank"
              href="https://www.icicibank.com/terms-condition?_ga=2.99502685.2128656069.1754985756-199590954.1741767507"
              onClick={() => {
                handleFormStart();
                ctaClickEvent(
                  "terms & conditions",
                  "lead form",
                  "text link",
                  0,
                  "https://www.icicibank.com/terms-condition?_ga=2.99502685.2128656069.1754985756-199590954.1741767507",
                );
              }}
              onContextMenu={() => {
                handleFormStart();
                ctaClickEvent(
                  "terms & conditions",
                  "lead form",
                  "text link",
                  0,
                  "https://www.icicibank.com/terms-condition?_ga=2.99502685.2128656069.1754985756-199590954.1741767507",
                );
              }}
            >
              Terms & Conditions
            </a>{" "}
            and{" "}
            <a
              target="_blank"
              href="https://campaigns.icicibank.com/hl/termsAndConditions/index.html"
              onClick={() => {
                handleFormStart();
                ctaClickEvent(
                  "most important terms & conditions",
                  "lead form",
                  "text link",
                  0,
                  "https://campaigns.icicibank.com/hl/termsAndConditions/index.html",
                );
              }}
              onContextMenu={() => {
                handleFormStart();
                ctaClickEvent(
                  "most important terms & conditions",
                  "lead form",
                  "text link",
                  0,
                  "https://campaigns.icicibank.com/hl/termsAndConditions/index.html",
                );
              }}
            >
              Most Important Terms & Conditions
            </a>{" "}
            prescribed by ICICI Bank Limited. I permit ICICI Bank Limited to
            share my contact details with ICICI Home Finance Company. Further, I
            specifically permit representatives from ICICI Bank Limited &amp;
            ICICI Home Finance Company to reach out to me through my registered
            e-mail, phone, SMS, WhatsApp messaging, or any other electronic mode
            or other messaging or social media platforms in relation to my home
            loan application.
          </label>
        </div>
        {errors.agreetnc && (
          <span className="error">{errors.agreetnc.message}</span>
        )}
        <button id="proceed" type="submit" className="proceed">
          Apply Now
        </button>
        <div className="toast-container" id="toastContainer"></div>
      </div>
    </form>
  );
}

export default FormComponent;
